/* Crni novembar landing — behaviour for the cn-* sections (vanilla JS, no deps). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var pad = function (n) { return String(n).padStart(2, '0'); };

  /* ---------- smooth scroll to anchors (#proizvodi, #kolekcije …) ---------- */
  function scrollToId(id) {
    var el = document.getElementById(id);
    if (!el) return false;
    var y = el.getBoundingClientRect().top + window.scrollY - 72;
    window.scrollTo({ top: y, behavior: 'smooth' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    if (scrollToId(id)) e.preventDefault();
  });

  /* ---------- header: off-canvas menu ---------- */
  function initHeader(root) {
    var burger = $('.om-burger', root), menu = $('.om-menu', root);
    if (!burger || !menu) return;
    var light = root.getAttribute('data-variant') === 'light';
    var panel = $('.om-panel', menu), scrim = $('.om-scrim', menu), hdr = $('.om-header', root);
    var set = function (open) {
      if (light && open && hdr) {
        // otvori meni ISPOD lepljivog headera (ne preko trake i navbara)
        var top = Math.max(0, hdr.getBoundingClientRect().bottom);
        panel.style.top = top + 'px'; panel.style.paddingTop = '32px';
        scrim.style.top = top + 'px';
      }
      burger.setAttribute('data-open', open ? 'open' : 'closed');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.setAttribute('data-open', open ? 'open' : 'closed');
      document.body.classList.toggle('cn-menu-open', open);
    };
    burger.addEventListener('click', function () { set(menu.getAttribute('data-open') !== 'open'); });
    $('.om-scrim', menu).addEventListener('click', function () { set(false); });
    $$('.om-link', menu).forEach(function (l) { l.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    if (root.getAttribute('data-variant') === 'light') {
      var header = $('.om-header', root);
      var onScroll = function () { header.setAttribute('data-solid', window.scrollY > 8 ? 'on' : 'off'); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
  }

  /* ---------- feature ticker: cycles items with slide-in/out ---------- */
  function initFeat(root) {
    var box = $('.cn-feat', root), items = $$('.cn-feat-item', root);
    if (!box || items.length < 2) return;
    var i = 0, interval = parseInt(root.getAttribute('data-interval'), 10) || 2600;
    items.forEach(function (it, n) { it.style.display = n === 0 ? 'flex' : 'none'; });
    setInterval(function () {
      var cur = items[i]; cur.style.animation = 'featOut 300ms cubic-bezier(.2,.7,.2,1) both';
      setTimeout(function () {
        cur.style.display = 'none'; cur.style.animation = '';
        i = (i + 1) % items.length; var nx = items[i];
        box.style.background = nx.getAttribute('data-bg') || '';
        nx.style.display = 'flex'; nx.style.animation = 'featIn 360ms cubic-bezier(.2,.7,.2,1) both';
      }, 300);
    }, interval);
  }

  /* ---------- YouTube play-on-click (vertical video box) ---------- */
  function initVideo(root) {
    var btn = $('.om-play', root), id = root.getAttribute('data-video-id');
    if (!btn || !id) return;
    btn.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&playsinline=1&rel=0';
      f.title = root.getAttribute('data-video-title') || 'Video';
      f.setAttribute('frameborder', '0'); f.setAttribute('allowfullscreen', '');
      f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      f.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;display:block;';
      btn.parentNode.replaceChild(f, btn);
    });
  }

  /* ---------- cart count in header ---------- */
  function setCartCount(n) {
    $$('[data-cn-cart-count]').forEach(function (b) {
      b.textContent = n;
      b.style.display = n > 0 ? 'flex' : 'none';
    });
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count || 0); })
      .catch(function () {});
  }

  /* ---------- hero slider ---------- */
  function initHero(root) {
    var slides = $$('.om-slide', root), dots = $$('.om-dot', root);
    if (slides.length < 2) return;
    var i = 0, timer, interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var apply = function (k) {
      i = (k + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.setAttribute('data-active', n === i ? 'on' : 'off'); });
      dots.forEach(function (d, n) { d.setAttribute('data-active', n === i ? 'on' : 'off'); });
    };
    var start = function () { clearInterval(timer); timer = setInterval(function () { apply(i + 1); }, interval); };
    dots.forEach(function (d, n) { d.parentElement.addEventListener('click', function () { apply(n); start(); }); });
    start();
  }

  /* ---------- countdown ---------- */
  function initCountdown(root) {
    var mode = root.getAttribute('data-mode') || 'daily';
    var date = root.getAttribute('data-date') || '';
    var hEl = $('[data-cn-h]', root), mEl = $('[data-cn-m]', root), sEl = $('[data-cn-s]', root), dEl = $('[data-cn-d]', root);
    var end = mode === 'date' ? new Date(date + 'T23:59:59').getTime() : 0;
    var tick = function () {
      var left;
      if (mode === 'date') {
        left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      } else {
        var n = new Date();
        left = 86400 - (n.getHours() * 3600 + n.getMinutes() * 60 + n.getSeconds());
      }
      if (dEl) {
        dEl.textContent = pad(Math.floor(left / 86400));
        if (hEl) hEl.textContent = pad(Math.floor(left / 3600) % 24);
      } else if (hEl) hEl.textContent = pad(Math.floor(left / 3600));
      if (mEl) mEl.textContent = pad(Math.floor(left / 60) % 60);
      if (sEl) sEl.textContent = pad(left % 60);
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- products: tabs, image strips, add to cart ---------- */
  function initProducts(root) {
    var tabs = $$('.om-tab', root), panels = $$('.cn-panel', root);
    var show = function (key) {
      tabs.forEach(function (t) { t.setAttribute('data-on', t.getAttribute('data-tab') === key ? 'on' : 'off'); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-tab') !== key; });
    };
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-tab')); }); });
    if (tabs.length) show(tabs[0].getAttribute('data-tab'));

    var tabStrip = $('.om-tabs', root);
    if (tabStrip) tabStrip.addEventListener('wheel', function (e) {
      if (tabStrip.scrollWidth > tabStrip.clientWidth && Math.abs(e.deltaY) > Math.abs(e.deltaX)) { tabStrip.scrollLeft += e.deltaY; e.preventDefault(); }
    }, { passive: false });

    initCards(root);
    if (root.getAttribute('data-sort') === 'best-selling') loadBestSelling(root);
  }

  /* ---------- best-selling: fetch /collections/<handle>?view=cn-json&sort_by=best-selling and re-render ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cardHtml(p, o) {
    var imgs = p.images.slice(0, o.images);
    var kicker = o.kickerSource === 'text' ? o.kickerText : o.kickerSource === 'tab' ? (o.tabKicker || '') : o.kickerSource === 'type' ? p.type : o.kickerSource === 'vendor' ? p.vendor : '';
    var badge = p.compare && o.badgeSale ? '<span style="position:absolute;top:12px;left:12px;padding:5px 10px;border-radius:3px;background:#B01E23;color:#fff;font:600 10px/14px \'Rubik\',sans-serif;letter-spacing:1.5px;text-transform:uppercase;">' + esc(o.badgeSale) + '</span>'
      : p['new'] && o.badgeNew ? '<span style="position:absolute;top:12px;left:12px;padding:5px 10px;border-radius:3px;background:#4D161A;color:#fff;font:600 10px/14px \'Rubik\',sans-serif;letter-spacing:1.5px;text-transform:uppercase;">' + esc(o.badgeNew) + '</span>' : '';
    var btnStyle = 'margin-top:auto;width:100%;height:48px;border:1.5px solid #15213B;border-radius:5px;background:#15213B;color:#fff;font:600 11px/16px \'Rubik\',sans-serif;letter-spacing:1.5px;text-transform:uppercase;white-space:nowrap;padding:0 8px;';
    var btn = '<button type="button" class="om-add" data-variant="' + esc(p.variant) + '" data-added="off" data-adding="' + esc(o.btnAdding) + '" data-added-label="' + esc(o.btnAdded) + '" style="' + btnStyle + 'cursor:pointer;">' + esc(o.btnAdd) + '</button>';
    return '<div class="cn-card" style="display:flex;flex-direction:column;gap:14px;min-width:0;height:100%;">' +
      '<div style="position:relative;aspect-ratio:1;border-radius:9px;overflow:hidden;background:#F2F0EC;">' +
        '<div class="om-strip om-pstrip" style="position:absolute;inset:0;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;cursor:grab;touch-action:pan-x pan-y;">' +
          imgs.map(function (u) { return '<img src="' + esc(u) + '" alt="' + esc(p.title) + '" loading="lazy" draggable="false" style="flex:none;width:100%;height:100%;object-fit:cover;display:block;scroll-snap-align:start;user-select:none;">'; }).join('') +
        '</div>' + badge + '</div>' +
      (imgs.length > 1 ? '<div style="display:flex;gap:3px;">' + imgs.map(function (_, i) { return '<span class="om-bar" data-on="' + (i === 0 ? 'on' : 'off') + '" style="flex:1;height:2px;background:#DEE2E6;"></span>'; }).join('') + '</div>' : '') +
      '<div style="display:flex;flex-direction:column;gap:6px;">' +
        (kicker ? '<span style="font:400 13px/18px \'Rubik\',sans-serif;color:#5D6472;">' + esc(kicker) + '</span>' : '') +
        '<h3 class="cn-card-title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3></div>' +
      '<div style="display:flex;align-items:baseline;gap:10px;flex-wrap:wrap;">' +
        '<span style="font:600 17px/24px \'Rubik\',sans-serif;color:' + (p.compare ? '#B01E23' : '#15213B') + ';">' + p.price + '</span>' +
        (p.compare ? '<span style="font:400 13px/18px \'Rubik\',sans-serif;color:#A3A8B2;text-decoration:line-through;">' + p.compare + '</span>' : '') +
      '</div>' + btn + '</div>';
  }
  /* Shopify (preview bar, apps) may append markup after the JSON — cut out the first top-level [...] array. */
  function extractJsonArray(t) {
    var start = t.indexOf('['); if (start < 0) throw new Error('no JSON array in response');
    var depth = 0, inStr = false, i;
    for (i = start; i < t.length; i++) {
      var c = t[i];
      if (inStr) { if (c === '\\') i++; else if (c === '"') inStr = false; continue; }
      if (c === '"') inStr = true;
      else if (c === '[' || c === '{') depth++;
      else if (c === ']' || c === '}') { depth--; if (depth === 0) return t.slice(start, i + 1); }
    }
    throw new Error('unterminated JSON array');
  }
  function loadBestSelling(root) {
    var o = {
      images: parseInt(root.getAttribute('data-images'), 10) || 3,
      kickerSource: root.getAttribute('data-kicker-source') || 'text', kickerText: root.getAttribute('data-kicker-text') || '',
      badgeSale: root.getAttribute('data-badge-sale') || '', badgeNew: root.getAttribute('data-badge-new') || '',
      btnAdd: root.getAttribute('data-btn-add') || 'Dodaj u korpu', btnAdding: root.getAttribute('data-btn-adding') || '…',
      btnAdded: root.getAttribute('data-btn-added') || 'Dodato'
    };
    $$('.cn-panel[data-handle]', root).forEach(function (panel) {
      var handle = panel.getAttribute('data-handle'); if (!handle) return;
      var limit = parseInt(panel.getAttribute('data-limit'), 10) || 8;
      fetch('/collections/' + encodeURIComponent(handle) + '?view=cn-json&sort_by=best-selling', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (t) { return JSON.parse(extractJsonArray(t)); })
        .then(function (list) {
          if (!Array.isArray(list) || !list.length) return;
          var po = Object.assign({}, o, { tabKicker: panel.getAttribute('data-kicker') || '' });
          panel.innerHTML = list.slice(0, limit).map(function (p) { return cardHtml(p, po); }).join('');
          initCards(panel);
        })
        .catch(function (e) { if (window.console) console.warn('[cn] best-selling fetch failed for', handle, e); });
    });
  }

  /* ---------- product cards: image strips + add to cart (scoped so re-rendered panels can re-init) ---------- */
  function initCards(root) {
    $$('.om-pstrip', root).forEach(function (strip) {
      var card = strip.closest('.cn-card'), bars = $$('.om-bar', card);
      var idx = function () { return Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth)); };
      strip.addEventListener('scroll', function () {
        var k = idx(); bars.forEach(function (b, n) { b.setAttribute('data-on', n === k ? 'on' : 'off'); });
      }, { passive: true });
      strip.addEventListener('mouseenter', function () {
        if (matchMedia('(hover:hover)').matches && idx() === 0 && strip.children.length > 1) {
          strip.dataset.hovered = '1'; strip.scrollTo({ left: strip.clientWidth, behavior: 'smooth' });
        }
      });
      strip.addEventListener('mouseleave', function () {
        if (strip.dataset.hovered) { delete strip.dataset.hovered; strip.scrollTo({ left: 0, behavior: 'smooth' }); }
      });
      strip.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) delete strip.dataset.hovered; }, { passive: true });
    });

    $$('.om-add[data-variant]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-added') === 'on' || btn.disabled) return;
        var id = btn.getAttribute('data-variant'), label = btn.textContent;
        btn.disabled = true; btn.textContent = btn.getAttribute('data-adding') || '…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            btn.disabled = false; btn.setAttribute('data-added', 'on');
            btn.textContent = btn.getAttribute('data-added-label') || 'Dodato';
            refreshCart();
            document.dispatchEvent(new CustomEvent('cn:cart:added', { detail: { variantId: id } }));
          })
          .catch(function () { btn.disabled = false; btn.textContent = label; });
      });
    });
  }
  /* (initProducts above handles tabs; initCards handles cards.) */

  /* ---------- drag-to-scroll with the mouse (tabs + product strips) ---------- */
  (function () {
    var el = null, x0 = 0, s0 = 0, moved = false;
    document.addEventListener('mousedown', function (e) {
      el = e.target.closest('.om-tabs,.om-pstrip'); if (!el) return;
      if (el.classList.contains('om-pstrip')) el.style.scrollSnapType = 'none';
      e.preventDefault(); x0 = e.clientX; s0 = el.scrollLeft; moved = false; el.style.cursor = 'grabbing';
    });
    document.addEventListener('mousemove', function (e) {
      if (!el) return; var dx = e.clientX - x0; if (Math.abs(dx) > 4) moved = true; el.scrollLeft = s0 - dx;
    });
    document.addEventListener('mouseup', function () {
      if (!el) return; el.style.cursor = 'grab';
      if (el.classList.contains('om-pstrip')) {
        var w = el.clientWidth, k = Math.round(el.scrollLeft / w);
        el.style.scrollSnapType = ''; el.scrollTo({ left: k * w, behavior: 'smooth' });
      }
      if (moved) {
        var stop = function (ev) { ev.stopPropagation(); ev.preventDefault(); el.removeEventListener('click', stop, true); };
        el.addEventListener('click', stop, true); setTimeout(function () { el.removeEventListener('click', stop, true); }, 50);
      }
      el = null;
    });
  })();

  /* ---------- testimonials ---------- */
  function initTestimonials(root) {
    var strip = $('.cn-tstrip', root), dots = $$('.om-tdot', root);
    if (!strip) return;
    var cards = strip.children, cur = 0;
    var w = function () { var c = cards[0]; return c ? c.getBoundingClientRect().width + 20 : 440; };
    var go = function (k) { k = Math.max(0, Math.min(cards.length - 1, k)); strip.scrollTo({ left: k * w(), behavior: 'smooth' }); };
    strip.addEventListener('scroll', function () {
      var k = Math.round(strip.scrollLeft / w());
      if (k !== cur) { cur = k; dots.forEach(function (d, n) { d.setAttribute('data-on', n === k ? 'on' : 'off'); }); }
    }, { passive: true });
    var p = $('.cn-tbtn-prev', root), n = $('.cn-tbtn-next', root);
    if (p) p.addEventListener('click', function () { go(cur - 1); });
    if (n) n.addEventListener('click', function () { go(cur + 1); });
  }

  /* ---------- FAQ + footer accordions ---------- */
  function initAccordion(root, btnSel, bodySel) {
    $$(btnSel, root).forEach(function (btn) {
      var item = btn.parentElement, body = $(bodySel, item), chev = $('.om-chev', btn);
      btn.addEventListener('click', function () {
        var open = body.hidden;
        if (root.getAttribute('data-single') === 'true') {
          $$(bodySel, root).forEach(function (b) { b.hidden = true; });
          $$('.om-chev', root).forEach(function (c) { c.setAttribute('data-open', 'closed'); });
        }
        body.hidden = !open; if (chev) chev.setAttribute('data-open', open ? 'open' : 'closed');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- sticky bar ---------- */
  function initSticky(root) {
    var bar = $('.om-stickybar', root); if (!bar) return;
    var delay = (parseFloat(root.getAttribute('data-delay')) || 2) * 1000, t = null;
    var onScroll = function () {
      if (t) return;
      t = setTimeout(function () { bar.setAttribute('data-show', 'show'); }, delay);
      window.removeEventListener('scroll', onScroll, true);
    };
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
  }

  /* ---------- pre / posle slajder ---------- */
  function initBA(el) {
    if (el.getAttribute('data-cn-ba') === 'ready') return;
    el.setAttribute('data-cn-ba', 'ready');
    var drag = false, x0 = 0, y0 = 0, decided = false;
    var set = function (x) {
      var r = el.getBoundingClientRect();
      var p = Math.max(2, Math.min(98, (x - r.left) / r.width * 100));
      el.style.setProperty('--p', p + '%');
    };
    el.addEventListener('pointerdown', function (e) {
      drag = true; x0 = e.clientX; y0 = e.clientY;
      decided = e.pointerType === 'mouse';
      if (decided) { el.classList.add('cn-ba-drag'); set(e.clientX); }
      try { el.setPointerCapture(e.pointerId); } catch (_) {}
    });
    el.addEventListener('pointermove', function (e) {
      if (!drag) return;
      if (!decided) {
        var dx = Math.abs(e.clientX - x0), dy = Math.abs(e.clientY - y0);
        if (dx < 6 && dy < 6) return;
        if (dy > dx) { drag = false; return; }
        decided = true; el.classList.add('cn-ba-drag');
      }
      e.preventDefault(); set(e.clientX);
    });
    var end = function (e) {
      if (drag && !decided && e && e.type === 'pointerup') set(e.clientX);
      drag = false; el.classList.remove('cn-ba-drag');
    };
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
  }

  /* ---------- boot (also re-run per section in the theme editor) ---------- */
  function boot(scope) {
    scope = scope || document;
    $$('[data-cn-ba]', scope).forEach(initBA);
    $$('[data-cn="header"]', scope).forEach(initHeader);
    $$('[data-cn="hero"]', scope).forEach(initHero);
    $$('[data-cn="countdown"]', scope).forEach(initCountdown);
    $$('[data-cn="products"]', scope).forEach(initProducts);
    $$('[data-cn="video"]', scope).forEach(initVideo);
    $$('[data-cn="feat"]', scope).forEach(initFeat);
    $$('[data-cn="cards"]', scope).forEach(initCards);
    $$('[data-cn="testimonials"]', scope).forEach(initTestimonials);
    $$('[data-cn="faq"]', scope).forEach(function (r) { initAccordion(r, '.cn-faq-q', '.cn-faq-a'); });
    $$('[data-cn="footer"]', scope).forEach(function (r) { initAccordion(r, '.cn-foot-toggle', '.cn-foot-list'); });
    $$('[data-cn="sticky"]', scope).forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); refreshCart(); });
  else { boot(); refreshCart(); }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target.closest('.cn-panel');
      if (panel) { var root = panel.closest('[data-cn="products"]'); $$('.om-tab', root).forEach(function (t) { if (t.getAttribute('data-tab') === panel.getAttribute('data-tab')) t.click(); }); }
      var slide = e.target.closest('.om-slide');
      if (slide) { var k = $$('.om-slide', slide.parentElement).indexOf(slide); var dots = $$('.om-dot', slide.closest('[data-cn="hero"]')); if (dots[k]) dots[k].parentElement.click(); }
    });
  }
})();
